import { useEffect, useRef, useMemo, useState } from 'react';
import moment from 'moment';
import { Card, Row, Col, Form, Button, DatePicker, Select } from 'antd';
import { headerStyle, rowStyle } from 'shared/styles/baseStyle';
import { useHistory, useLocation } from 'react-router-dom';
import EndPoints from 'shared/endPoints/EndPoints.json';
import { getToday } from 'shared/utils/dateUtils';
import EmissionsStatus from './EmissionsStatus';

const POLICY_DURATION_6 = '6';
const POLICY_DURATION_12 = '12';

const CHANNEL_ANYTIME = '1';
const CHANNEL_IM = '2';

const CONTACT_NO_1 = '1';
const CONTACT_NO_2 = '2';

export default function SearchEmissions() {
  const { search } = useLocation();
  const queryParams = useMemo(() => new URLSearchParams(search), [search]);
  const defaultExportFilename = `Report_${getToday().today}`;
  const [exportFilename, setExportFilename] = useState(defaultExportFilename);
  const dateFormat = 'D/M/YYYY';
  const [form] = Form.useForm();
  const myRef = useRef();
  const history = useHistory();
  const [endPoint, setEndPoint] = useState();

  const formItemLayout = {
    labelCol: {
      span: 10
    },
    wrapperCol: {
      span: 12
    }
  };

  const executeScroll = () =>
    myRef.current.scrollIntoView({ behavior: 'smooth' });

  useEffect(() => {
    const channelPrefix =
      queryParams.get('channel') === CHANNEL_ANYTIME ? 'AN_' : 'IM_';
    form.setFieldsValue({
      policyStartDateFrom: queryParams.get('policyStartDateFrom')
        ? moment(queryParams.get('policyStartDateFrom'), dateFormat)
        : null,
      policyStartDateTo: queryParams.get('policyStartDateTo')
        ? moment(queryParams.get('policyStartDateTo'), dateFormat)
        : null,
      policyDuration: queryParams.get('policyDuration')
        ? queryParams.get('policyDuration')
        : 'ALL',
      channel: queryParams.get('channel') ? queryParams.get('channel') : 'ALL',
      contactNo: queryParams.get('contactNo')
        ? queryParams.get('contactNo')
        : 'ALL'
    });
    setExportFilename(
      queryParams.get('channel')
        ? `${channelPrefix}${defaultExportFilename}`
        : defaultExportFilename
    );
    setEndPoint(
      `${EndPoints.REPORTS.CONTRACTEMISSIONSSUMMARY}?${queryParams.toString()}`
    );
  }, [queryParams, form]);

  const onFinish = fieldsValues => {
    const values = {
      ...fieldsValues,
      policyStartDateFrom: fieldsValues.policyStartDateFrom?.format(dateFormat),
      policyStartDateTo: fieldsValues.policyStartDateTo?.format(dateFormat),
      policyDuration:
        fieldsValues.policyDuration === POLICY_DURATION_6 ||
        fieldsValues.policyDuration === POLICY_DURATION_12
          ? parseInt(fieldsValues.policyDuration, 10)
          : null,

      channel: fieldsValues.channel !== 'ALL' ? fieldsValues.channel : null,
      contactNo:
        fieldsValues.contactNo !== 'ALL' ? fieldsValues.contactNo : null
    };
    Object.keys(values).forEach(key =>
      values[key] === null || values[key] === undefined || values[key] === ''
        ? delete values[key]
        : values[key]
    );
    const params = new URLSearchParams(values);
    history.replace({ search: `?${params}` });
    setEndPoint(`${EndPoints.REPORTS.CONTRACTEMISSIONSSUMMARY}?${params}`);
    executeScroll();
  };

  return (
    <>
      <Card
        type="inner"
        headStyle={headerStyle}
        title="Συμπληρώστε οποιοδήποτε από τα πεδία και στη συνέχεια πατήστε το κουμπί Αναζήτηση"
      >
        <Row style={rowStyle}>
          <Col style={{ color: 'black' }} span={24}>
            Κριτήρια Αναζήτησης
          </Col>
        </Row>
        <Form {...formItemLayout} form={form} onFinish={onFinish}>
          <Row>
            <Col span={12}>
              <Form.Item
                name="policyStartDateFrom"
                label="Ημερομηνία Έναρξης Από:"
              >
                <DatePicker format={dateFormat} style={{ width: '70%' }} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="policyStartDateTo"
                label="Ημερομηνία Έναρξης Έως:"
              >
                <DatePicker format={dateFormat} style={{ width: '70%' }} />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="policyDuration" label="Διάρκεια Συμβολαίου:">
                <Select
                  defaultValue=""
                  options={[
                    { value: '', label: 'ALL' },
                    { value: POLICY_DURATION_6, label: '6 Μήνες' },
                    { value: POLICY_DURATION_12, label: '12 Μήνες' }
                  ]}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="contactNo" label="ContactNo:">
                <Select
                  defaultValue=""
                  options={[
                    { value: '', label: 'ALL' },
                    { value: CONTACT_NO_1, label: '1' },
                    { value: CONTACT_NO_2, label: '2' }
                  ]}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="channel" label="Channel:">
                <Select
                  defaultValue="ALL"
                  options={[
                    { value: CHANNEL_ANYTIME, label: 'Anytime' },
                    { value: CHANNEL_IM, label: 'IM' },
                    { value: 'ALL', label: 'ALL' }
                  ]}
                />
              </Form.Item>
            </Col>
            <Col span={8} offset={10}>
              <Form.Item>
                <Button
                  htmlType="submit"
                  style={{ backgroundColor: '#e6e6e6' }}
                >
                  Αναζήτηση
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Card>
      <Col ref={myRef}>
        <EmissionsStatus endPoint={endPoint} exportFilename={exportFilename} />
      </Col>
    </>
  );
}
